import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import axios from 'axios';

import logo01 from '../../assets/logos/cetificated.png';
import { Link } from 'react-router-dom';

function Login() {
  const [showLogin, setShowLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const { token, currentUser } = useContext(AuthContext);

  const handleLogin = async () => {
    const lang = 'es';
    setError('');

    if (!email || !password) {
      setError('Email y contraseña son requeridos');
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/${lang}/auth/login`,
        { email, password }
      );

      if (response.status === 200) {
        const receivedToken = response.data.token;
        localStorage.setItem('userToken', receivedToken);

        window.location.href = '/admin';
      } else {
        setError('Ups!');
      }
    } catch (error) {
      const { response } = error;
      if (response && response.data && response.data.message) {
        setError(response.data.message);
      } else {
        setError('Ups!');
      }
    }
  };

  const handleKeyDown = e => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  useEffect(() => {
    if (token && currentUser) {
      setShowLogin(false);
    }
  }, [currentUser]);

  return (
    <>
      <div
        className="container-fluid bg-sen d-flex flex-column"
        style={{ minHeight: 'calc(100vh - 65px)' }}
      >
        <div className="row justify-content-center align-items-center flex-grow-1">
          <div className="col-12 col-md-4 col-lg-3 login">
            <div className="text-center">
              <img src={logo01} alt="Logo 1" className="logo mb-2" />
            </div>
            {showLogin && (
              <>
                <div className="input-group mb-3">
                  <span className="input-group-text bg-transparent border-end-0">
                    <i className="fa fa-user"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control bg-transparent border-start-0"
                    id="email"
                    placeholder="Email"
                    onChange={e => setEmail(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div className="input-group mb-3">
                  <span className="input-group-text bg-transparent border-end-0">
                    <i className="fa fa-lock"></i>
                  </span>
                  <input
                    type="password"
                    className="form-control bg-transparent border-start-0"
                    id="password"
                    placeholder="Password"
                    onChange={e => setPassword(e.target.value)}
                    onKeyDown={handleKeyDown}
                  />
                </div>
                <div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        className="form-check-input bg-transparent"
                        id="rememberMe"
                      />
                      <label className="form-check-label small text-dark" htmlFor="rememberMe">
                        Remember me
                      </label>
                    </div>
                    <Link to="/forgot" className="small text-dark">
                      Forgot password?
                    </Link>
                  </div>
                </div>
                <div className="">
                  <button
                    type="button"
                    className="btn btn-dark btn-login mt-2"
                    onClick={handleLogin}
                  >
                    <span className="small">LOGIN</span>
                  </button>
                </div>
                {error && <p className="text-danger mt-2 small">{error}</p>}
              </>
            )}
            {!showLogin && (
              <div className="text-center">
                <p className="mb-3">Ya has iniciado sesión.</p>
                <div className="d-flex flex-column gap-2">
                  <Link to="/admin" className="btn btn-dark text-decoration-none">
                    <i className="fa fa-dashboard me-2"></i>Panel de Control
                  </Link>
                  <Link to="/profile" className="btn btn-sen text-white text-decoration-none">
                    <i className="fa fa-user me-2"></i>Ir a Mi Perfil / Cambiar Contraseña
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
